/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const generateTimeOptions = (
  is24Hour: boolean,
  interval: number,
  showSeconds?: boolean,
) => {
  const times: string[] = [];
  const safeInterval = interval || 30;
  // The dropdown lists times at the minute interval; when seconds are shown the
  // options are anchored at `:00` and the user can type a more precise value.
  const secondsSuffix = showSeconds === true ? ':00' : '';
  for (let minute = 0; minute < 1440; minute += safeInterval) {
    const hours = Math.floor(minute / 60);
    const minutes = minute % 60;
    if (is24Hour) {
      times.push(
        `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}${secondsSuffix}`,
      );
    } else {
      const period = hours < 12 ? 'AM' : 'PM';
      const adjustedHours = hours % 12 || 12;
      times.push(
        `${String(adjustedHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}${secondsSuffix} ${period}`,
      );
    }
  }
  return times;
};
